import { paths } from '../../../../../common/constants/pathVariables';
import { omaElisaForCompaniesMsg, t, warrantyReceiptsMsg } from '../../../../../common/i18n';
import { MessageCenter } from '../../../../../components/MessageCenter/MessageCenter';
import { WarrantyReceipts } from '../../../../../components/MessageCenter/WarrantyReceipts';

export const WarrantyReceiptsPath = () => {
  return (
    <MessageCenter
      breadCrumbs={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.SZY8(warrantyReceiptsMsg) },
      ]}
    >
      <WarrantyReceipts />
    </MessageCenter>
  );
};
